module.exports = __webpack_public_path__ + "static/media/live-event-hour.63f25798.svg";